import { SELECT_TRIGGER_TYPE } from '../actions/trigger';

const DEFAULT_STATE = {
  triggerValues: {}
};

export default function Trigger(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SELECT_TRIGGER_TYPE:
      return {
        ...state,
        selectedTriggerType: action.selectedTriggerType
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/trigger.js